import MarketingNav from "@/components/MarketingNav";
import MarketingFooter from "@/components/MarketingFooter";
import PlatformSupportChat from "@/components/PlatformSupportChat";

/** Marketing chrome for public CMS pages (About, Products, Features,
 *  How-it-works, Help, Demos, legal, technical). Single source of truth —
 *  swap this and every marketing page updates uniformly.
 *
 *  Landing keeps its own MarketingNav + MarketingFooter usage so it can
 *  pass `variant="dark"` for the hero band; components are the same.
 */
export default function MarketingShell({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-white">
            <MarketingNav />
            <main className="flex-1">{children}</main>
            <MarketingFooter />
            <PlatformSupportChat />
        </div>
    );
}

// Backwards-compat: nothing else imports these but keep the file self-
// contained for future needs.
